// extracted by mini-css-extract-plugin
export default {"header":"Table_header__SJrqe","link":"Table_link__KA6c-"};